import EventHandler from '@pixelunion/events';
import Share from './Share';
import ProductQuickshop from './ProductQuickshop';

const isQuickShopTrigger = el => 'quickshopTrigger' in el.dataset;

export default class ProductList {
  constructor({ el, id }) {
    this.el = el;
    this.id = id;
    this._onRimgLoad = this._processImage.bind(this);
    this._load();
  }

  reload() {
    // Only Share needs to be reloaded, everything else
    // operates on the overall element and will inherently
    // handle new content.
    this.share.unload();
    this.share = new Share({ el: this.el });
  }

  unload() {
    this.el.removeEventListener('rimg:load', this._onRimgLoad);
    this.share.unload();
    this.events.unregisterAll();
    this.quickshops.forEach(quickshop => quickshop.unload());
  }

  _load() {
    this.el.addEventListener('rimg:load', this._onRimgLoad);
    this.share = new Share({ el: this.el });
    this.quickshops = new Map();

    this.events = new EventHandler();

    this.events.register(this.el, 'focusin', e => this._loadQuickshop(e.target));
    this.events.register(this.el, 'mouseover', e => this._loadQuickshop(e.target));
    this.events.register(this.el, 'click', e => this._openQuickshop(e.target));
  }

  _getQuickshop(el) {
    let quickshop = this.quickshops.get(el);

    if (quickshop) return quickshop;

    quickshop = new ProductQuickshop({
      el,
      id: this.id,
      url: el.dataset.productQuickshopUrl,
      hash: el.dataset.productQuickshopHash,
      // Ideally the trigger would be the actual quick shop trigger, but product cards
      // need a bunch of accessibility improvements before we can focus on that element
      trigger: el.closest('[data-product-item-id]').querySelector('[data-quickshop-trigger]'),
    });

    this.quickshops.set(el, quickshop);
    return quickshop;
  }

  _loadQuickshop(target) {
    if (!isQuickShopTrigger(target)) return;

    const productItemEl = target.closest('[data-product-item-id]');
    const quickshopEl = productItemEl.querySelector('[data-product-quickshop]');

    this._getQuickshop(quickshopEl).load();
  }

  _openQuickshop(target) {
    if (!isQuickShopTrigger(target)) return;

    const productItemEl = target.closest('[data-product-item-id]');
    const quickshopEl = productItemEl.querySelector('[data-product-quickshop]');
    this._getQuickshop(quickshopEl).open();
  }

  _processImage() {
    const unprocessedImages = this.el.querySelectorAll('.product-item-image:not(.processed)');

    for (let i = 0; i < unprocessedImages.length; i++) {
      const imageWrapper = unprocessedImages[i];
      const image = imageWrapper.querySelector('img');

      imageWrapper.classList.add('processed');

      if (image && image.getBoundingClientRect().height < 100) {
        const imageOverlay = imageWrapper.querySelector('.product-item-details-overlay');
        if (imageOverlay) {
          imageOverlay.classList.add('landscape');
        }
      }
    }
  }
}
